// export const API = "http://api-client.monitoring.web.id/";
// export const ASSETS_URL = "http://administrator.monitoring.web.id/assets/";
export const API = "https://api-client.medmon.cloud/";
export const ASSETS_URL = "https://administrator.medmon.cloud/assets/";
export const CLIENT = 44;
export const MEDIA_TYPE = ['Online', 'TV', 'Cetak', 'Radio'];
export const TONE = ['Negatif', 'Netral', 'Positif', 'Internal'];